import React, { useEffect, useRef, useState } from 'react';
import styles from "./index.module.scss";

import Phaser from 'phaser';
import GameScene from '../../Components/GameScene/FireGame';

export default function Game() {
  const gameRef = useRef(null);
  const gameContainerRef = useRef(null);

  useEffect(() => {
    if (gameRef.current || !gameContainerRef.current) return;

    const config = {
      type: Phaser.AUTO,
      width: window.innerWidth,
      height: window.innerHeight,
      parent: gameContainerRef.current,
      physics: {
        default: "matter",
        matter: {
          gravity: { x: 0, y: 0 },
        },
      },
      scale: {
        mode: Phaser.Scale.RESIZE,
        autoCenter: Phaser.Scale.CENTER_BOTH,
      },
      scene: [GameScene],
    };

    gameRef.current = new Phaser.Game(config);

    const handleResize = () => {
      if (gameRef.current) {
        gameRef.current.scale.resize(window.innerWidth, window.innerHeight);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      gameRef.current?.destroy(true);
      gameRef.current = null;
    };
  }, []);

  return (
    <>
      <div
        id="game-intro"
        style={{
          position: "fixed",
          zIndex: 100,
          width: "100dvw",
          height: "100dvh",
          backgroundColor: "black",
        }}
      >
        <div

          style={{
            position: "absolute",
            backgroundImage: `url('/assets/intro.png')`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundColor: "black",
            backgroundSize: "100% 100%",
            height:"100%",
            maxHeight: "100dvh",
            maxWidth: "100dvw",
            aspectRatio: "4/3",
            left: "50%",
            transform: "translateX(-50%)",
          }}

        />
      </div>
      <div className={styles.Game}>
        <div ref={gameContainerRef} className={styles.GameCanvas}></div>
      </div>
    </>
  );
}
